import React from 'react';
import PropTypes from 'prop-types';
import Breakpoints from 'react-breakpoints';

import NavigationDropdownWrapper from './navigation_dropdown_wrapper';

import './styles/navigation_dropdown.scss';

const breakpoints = {
  mobile: 768,
  desktop: 769,
};

// need to wrap in breakpoint to detect mobile
const NavigationDropdownBreakPoints = (props) => (
  <Breakpoints breakpoints={breakpoints}>
    <NavigationDropdownWrapper {...props} />
  </Breakpoints>
);

NavigationDropdownBreakPoints.defaultProps = {
  libraryName: "Brandfolder",
};

NavigationDropdownBreakPoints.propTypes = {
  libraryName: PropTypes.string,
};

export default NavigationDropdownBreakPoints;
